import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CloseFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M18.7 17.22L17.26 18.66L12 13.4L6.74 18.66L5.3 17.22L10.56 11.96L5.3 6.7L6.74 5.26L12 10.52L17.26 5.26L18.7 6.7L13.44 11.96L18.7 17.22Z" />
    </SvgIcon>
  );
});
